import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export interface VehicleSalesData {
  uniqueid?: string;
  sale_id: string;
  sale_date: string;
  location_code: string;
  sale_details: any[];
  created_at?: string;
  updated_at?: string;
}

export interface BulkImportResult {
  success: number;
  failed: number;
  errors: Array<{
    sale_id: string;
    error: string;
  }>;
}

class VehicleSalesService {
  private getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  async bulkCreate(salesData: VehicleSalesData[]): Promise<BulkImportResult> {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/vehicle-sales/bulk`,
        { sales_data: salesData },
        { headers: this.getAuthHeaders() }
      );
      
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Import failed');
      }
    } catch (error: any) {
      console.error('Error importing vehicle sales data:', error);
      throw new Error(error.response?.data?.message || error.message || 'Failed to import data');
    }
  }

  async getAll(filters?: {
    location_code?: string;
    sale_date_from?: string;
    sale_date_to?: string;
    limit?: number;
    offset?: number;
  }) {
    try {
      const params = new URLSearchParams();
      if (filters?.location_code) params.append('location_code', filters.location_code);
      if (filters?.sale_date_from) params.append('sale_date_from', filters.sale_date_from);
      if (filters?.sale_date_to) params.append('sale_date_to', filters.sale_date_to);
      if (filters?.limit) params.append('limit', filters.limit.toString());
      if (filters?.offset) params.append('offset', filters.offset.toString());

      const response = await axios.get(
        `${API_BASE_URL}/vehicle-sales?${params.toString()}`,
        { headers: this.getAuthHeaders() }
      );
      
      if (response.data.success) {
        return response.data;
      } else {
        throw new Error(response.data.message || 'Failed to fetch data');
      }
    } catch (error: any) {
      console.error('Error fetching vehicle sales data:', error);
      throw error;
    }
  }

  async getById(id: string) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/vehicle-sales/${id}`,
        { headers: this.getAuthHeaders() }
      );
      
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to fetch data');
      }
    } catch (error: any) {
      console.error('Error fetching vehicle sales data:', error);
      throw error;
    }
  }

  async delete(id: string) {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/vehicle-sales/${id}`,
        { headers: this.getAuthHeaders() }
      );
      
      if (response.data.success) {
        return true;
      } else {
        throw new Error(response.data.message || 'Failed to delete data');
      }
    } catch (error: any) {
      console.error('Error deleting vehicle sales data:', error);
      throw error;
    }
  }
}

export default new VehicleSalesService();

















